/**
 * Card — React (web) implementation.
 */

/// <reference lib="dom" />

import React, { type ReactNode } from 'react';
import type { CardProps } from './Card';
import {
  CARD_PADDING,
  cardColorsFor,
  cardPaddingBottom,
  cardRadiusFor,
  splitCardBand,
} from './Card';
import { CardShell } from '../_card/internals.web';
import { spacingValue } from '../Stack/Stack';

export interface WebCardProps extends Partial<CardProps> {
  children?: ReactNode;
  'data-testid'?: string;
}

export function Card({
  background,
  paddingVertical,
  paddingHorizontal,
  paddingBottom,
  footerBand,
  fillHeight,
  radius,
  children,
  testID,
  'data-testid': dataTestId,
}: WebCardProps) {
  const colors = cardColorsFor(background);
  const { body, band } = splitCardBand(children, footerBand);

  return (
    <CardShell
      colors={colors}
      paddingX={paddingHorizontal === undefined ? CARD_PADDING : spacingValue(paddingHorizontal)}
      paddingY={paddingVertical === undefined ? CARD_PADDING : spacingValue(paddingVertical)}
      paddingBottom={cardPaddingBottom(paddingBottom, paddingVertical)}
      band={band}
      bandSurface={footerBand === undefined ? undefined : cardColorsFor(footerBand).surface}
      fillHeight={fillHeight}
      radius={radius === undefined ? undefined : cardRadiusFor(radius)}
      testId={dataTestId ?? testID}
    >
      {body}
    </CardShell>
  );
}
